import { render, staticRenderFns } from "./ButtonGooglePlay.vue?vue&type=template&id=85fbf6d2&"
import script from "./ButtonGooglePlay.vue?vue&type=script&lang=js&"
export * from "./ButtonGooglePlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports